import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
// Bootstrap
import { Container, Row, Col } from 'react-bootstrap'; // JSS

import { RichText, Image } from '@sitecore-jss/sitecore-jss-react'; // Type defintitions

import * as TYPES from '../../types'; // Design System

import Wrapper from '../wrapper/Wrapper';
import ContentBlockTile from './ContentBlockTile';
import ContentBlockExpand from './ContentBlockExpand';
import VideoImage from '../videoimage/VideoImage';
import gaTracker from '../../util/ga-analytics/gaTracker';

var ContentBlock = function ContentBlock(props) {
  var _model$image, _model$image$value, _model$videoUrl, _model$videoUrl$value, _model$image2, _model$image2$value, _model$videoUrl2, _model$videoUrl2$valu, _props$text, _model$showMoreText;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      _props$ctaLink = props.ctaLink,
      ctaLink = _props$ctaLink === void 0 ? {} : _props$ctaLink,
      alignment = props.alignment,
      isArticle = props.isArticle,
      _props$isMenu = props.isMenu,
      isMenu = _props$isMenu === void 0 ? false : _props$isMenu,
      _props$rendering = props.rendering,
      rendering = _props$rendering === void 0 ? {} : _props$rendering;
  var alignClass = typeof alignment !== 'undefined' ? "cb-content-block--".concat(alignment) : '';
  /*
  If there's an image the text will be defaulted left and
  the alignement will trigger the position of the image
  */

  if ((model === null || model === void 0 ? void 0 : (_model$image = model.image) === null || _model$image === void 0 ? void 0 : (_model$image$value = _model$image.value) === null || _model$image$value === void 0 ? void 0 : _model$image$value.src) || (model === null || model === void 0 ? void 0 : (_model$videoUrl = model.videoUrl) === null || _model$videoUrl === void 0 ? void 0 : (_model$videoUrl$value = _model$videoUrl.value) === null || _model$videoUrl$value === void 0 ? void 0 : _model$videoUrl$value.href)) {
    alignClass = "cb-content-block--image-".concat(alignment);
  }

  var type = {
    sm: '12',
    lg: '6'
  };

  if (typeof layout.type !== 'undefined') {
    if (layout.type === 'list') {
      type.lg = '3';
    }
  }

  var imageExists = (model === null || model === void 0 ? void 0 : (_model$image2 = model.image) === null || _model$image2 === void 0 ? void 0 : (_model$image2$value = _model$image2.value) === null || _model$image2$value === void 0 ? void 0 : _model$image2$value.src) || (model === null || model === void 0 ? void 0 : (_model$videoUrl2 = model.videoUrl) === null || _model$videoUrl2 === void 0 ? void 0 : (_model$videoUrl2$valu = _model$videoUrl2.value) === null || _model$videoUrl2$valu === void 0 ? void 0 : _model$videoUrl2$valu.href);

  var contentBlockClick = function contentBlockClick() {
    var data = {
      gtm: {
        uniqueEventId: '140',
        elementId: rendering.dataSource || ""
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: alignClass
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    onClick: contentBlockClick,
    id: "block-".concat(rendering.dataSource || "")
  }, imageExists && !isArticle ? /*#__PURE__*/React.createElement(Col, _extends({}, type, {
    className: "cb-content-block__image-container"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-content-block__image-wrapper"
  }, /*#__PURE__*/React.createElement(VideoImage, {
    image: model.image,
    video: model.videoUrl,
    className: "cb-content-block__image"
  }))) : null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ContentBlockTile, _extends({}, props, {
    model: model,
    alignment: alignment,
    className: "".concat(alignClass, " ").concat(imageExists ? "" : "cb-content-block__tilealone", " ").concat(isArticle ? "cb-content-block__article" : "", " ").concat(!isArticle && ((_props$text = props.text) === null || _props$text === void 0 ? void 0 : _props$text.value) !== '' ? 'cb-content-block__article-detail' : ''),
    isMenu: isMenu
  })))), typeof (model === null || model === void 0 ? void 0 : model.showMoreText) !== 'undefined' && (model === null || model === void 0 ? void 0 : (_model$showMoreText = model.showMoreText) === null || _model$showMoreText === void 0 ? void 0 : _model$showMoreText.value) !== '' ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ContentBlockExpand, {
    model: model === null || model === void 0 ? void 0 : model.showMoreText,
    alignment: alignment
  }))) : null));
};

export default ContentBlock;